<template>
  <div id="services-list">
    <div class="header-wrapper">
      <p class="header-wrapper__title">
        Специальные услуги
      </p>
      <div class="buttons">
        <vs-button
          v-if="userRole === 'admin'"
          class="add-button"
          color="primary"
          type="filled"
          size="small"
          @click="openForm()">
          <img
            src="@/assets/icons/plus.svg" />
        </vs-button>
      </div>
    </div>

    <div
      ref="loading"
      class="data-list">
      <table>
        <tr class="titles">
          <th
            class="titles__item"
            width="50%">
            Название
          </th>
          <th class="titles__item titles__item_sort" @click="sortChange('baseCost')">
            <span class="flex">
              Стоимость, ₽
              <span class="sort-th">
                <img
                  v-if="filterSort && (filterSort['baseCost'] === 1 || !filterSort['baseCost'])"
                  src="@/assets/icons/expand_less.svg"
                  class="up-sort" />
                <img
                  v-else
                  src="@/assets/icons/expand_less.svg"
                  class="down-sort" />
              </span>
            </span>
          </th>
          <th class="titles__item titles__item_sort" @click="sortChange('cleanerCost')">
            <span class="flex">
              Ставка клинера, ₽
              <span class="sort-th">
                <img
                  v-if="filterSort && (filterSort['cleanerCost'] === 1 || !filterSort['cleanerCost'])"
                  src="@/assets/icons/expand_less.svg"
                  class="up-sort" />
                <img
                  v-else
                  src="@/assets/icons/expand_less.svg"
                  class="down-sort" />
              </span>
            </span>
          </th>
          <th class="titles__item titles__item_sort" @click="sortChange('status')">
            <span class="flex">
              Статус
              <span class="sort-th">
                <img
                  v-if="filterSort && (filterSort['status'] === 1 || !filterSort['status'])"
                  src="@/assets/icons/expand_less.svg"
                  class="up-sort" />
                <img
                  v-else
                  src="@/assets/icons/expand_less.svg"
                  class="down-sort" />
              </span>
            </span>
          </th>
        </tr>
        <tr
          v-for="(service, index) in (mainServiceId ? services : mainServices)"
          :key="index"
          @click="openForm(service)"
          class="row">
          <td class="row__column">{{ service.name }}</td>
          <td class="row__column">{{ service.baseCost | toNumberFormat }}</td>
          <td class="row__column">{{ service.cleanerCost | toNumberFormat }}</td>
          <td
            :class="{ 'text-primary': service.status === 'active' }"
            class="row__column">
            {{ statuses[service.status] || service.status }}
          </td>
        </tr>
      </table>
    </div>
    
    <vs-popup
      :active.sync="serviceForm"
      class="popup-form">
      <service-form
        :id="activeServiceId ? activeServiceId : undefined"
        :city-id="activeCity.id"
        :main-service-id="+$route.params.id"
        type="specialAdditional"
        @close="onCloseForm" />
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import serviceForm from '@/components/serviceForm'

export default {
  name: 'ServicesList',

  filters: {
    toNumberFormat(val) {
      return val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '-'
    }
  },

  components: {
    serviceForm
  },

  props: {
    mainServiceId: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      activeCityId: 'city/activeCityId',
      userRole: 'user/role'
    })
  },

  data() {
    return {
      services: [],
      serviceForm: false,
      activeServiceId: '',
      filters: {},
      filterSort: {},
      activeCity: {},
      statuses: {
        active: 'Активна',
        unactive: 'Не активна'
      }
    }
  },

  watch: {
    mainServiceId() {
      this.getCity()
      this.fetchServices()
    }
  },

  mounted() {
    this.fetchServices()
    if (this.mainServiceId) {
      this.getCity()
    }
  },

  methods: {
    async fetchServices() {
      this.$vs.loading({
        container: this.$refs.loading,
        scale: 0.45
      })

      const query = {
        $sort: this.filterSort,
        $limit: -1,
        // type: 'specialAdditional',
        nestedMainServiceId: this.mainServiceId
      }
      if (this.activeCity && this.activeCity.id) {
        query.cityId = this.activeCity.id
      } else if (this.activeCityId) {
        query.cityId = this.activeCityId
      }

      this.services = await this.$apiClient.service('services').find({ query })

      this.$vs.loading.close(this.$refs.loading)
    },

    async getCity() {
      const mainService = await this.$apiClient.service('services').get(this.mainServiceId)
      this.activeCity = await this.$apiClient.service('cities').get(mainService.cityId)
    },

    openForm(service) {
      this.activeServiceId = service ? service.id : ''
      this.serviceForm = true
    },

    sortChange(field) {
      const sort = {}
      sort[field] = this.filterSort && this.filterSort[field] === 1 || this.filterSort[field] === undefined ? -1 : 1
      this.filterSort = sort
      
      this.fetchServices()
    },

    async onCloseForm(service) {
      const activeService = await this.$apiClient.service('services').get(this.mainServiceId)
      let servicesIds
      if (Array.isArray(activeService.servicesIds)) {
        servicesIds = [ ...activeService.servicesIds, service.id ]
        servicesIds = [ ...new Set(servicesIds) ]
      } else {
        servicesIds = [service.id]
      }
      await this.$apiClient.service('services').patch(this.mainServiceId, {
        servicesIds
      })
      this.$emit('services-update', servicesIds)
      this.fetchServices()
      this.serviceForm = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pages/controls/services/additionalServicesList.scss';
</style>